/* Quick Shower: gallery, scent picker, sticky bar, delivery dates. Works alongside bundle apps (Kaching) that edit the product form. */
(function () {
  if (window.__qsLoaded) return;
  window.__qsLoaded = true;

  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function initShip(root) {
    var el = root.querySelector('[data-qs-ship]');
    if (!el) return;
    var out = el.querySelector('[data-ship-dates]');
    var min = parseInt(el.dataset.min, 10) || 7;
    var max = parseInt(el.dataset.max, 10) || 12;
    var o = { month: 'short', day: 'numeric' };
    var now = new Date();
    out.textContent = addBusinessDays(now, min).toLocaleDateString(undefined, o) + ' – ' + addBusinessDays(now, max).toLocaleDateString(undefined, o);
  }

  function initGallery(root) {
    var g = root.querySelector('[data-qs-gallery]');
    if (!g) return null;
    var track = g.querySelector('[data-track]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
    var slides = Array.prototype.slice.call(track.children);
    function go(i) {
      var s = slides[i];
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.thumb, 10)); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var active = thumbs[i];
        if (active) {
          var bar = active.parentNode;
          bar.scrollLeft = active.offsetLeft - bar.clientWidth / 2 + active.clientWidth / 2;
        }
        ticking = false;
      });
    }, { passive: true });
    return {
      toMedia: function (mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].dataset.mediaId) === String(mediaId)) { go(i); return; }
        }
      }
    };
  }

  function initBuy(root) {
    var product = JSON.parse(root.querySelector('[data-qs-product]').textContent);
    var sPos = parseInt(root.dataset.scentPos, 10);
    var form = root.querySelector('[data-qs-form]');
    var idInput = root.querySelector('[data-variant-input]');
    var atc = root.querySelector('[data-qs-atc]');
    var err = root.querySelector('[data-qs-error]');
    var scentName = root.querySelector('[data-scent-name]');
    var sticky = root.querySelector('[data-qs-sticky]');
    var gallery = initGallery(root);
    initShip(root);

    function scent() {
      var el = root.querySelector('[data-scent]:checked');
      return el ? el.value : null;
    }

    function update(fromScent) {
      var s = scent();
      err.textContent = '';
      if (scentName) scentName.textContent = s || '';
      if (sticky) sticky.querySelector('[data-sticky-name]').textContent = product.title.replace(/™/g, '') + (s ? ' · ' + s : '');
      if (!s || !sPos) return;
      var v = product.variants.find(function (x) { return x['option' + sPos] === s; });
      if (!v) return;
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      atc.disabled = !v.available;
      if (fromScent && gallery && v.featured_media) gallery.toMedia(v.featured_media.id);
    }

    root.querySelectorAll('[data-scent]').forEach(function (r) { r.addEventListener('change', function () { update(true); }); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      atc.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
        window.location.href = root.dataset.skipCart === 'true' ? '/checkout' : '/cart';
      }).catch(function (e2) {
        err.textContent = e2.message + '. Try again, or refresh the page.';
        atc.disabled = false;
      });
    });

    if (sticky && 'IntersectionObserver' in window) {
      var btn = sticky.querySelector('[data-sticky-btn]');
      btn.addEventListener('click', function () { root.scrollIntoView({ behavior: 'smooth' }); });
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', off);
        sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        btn.tabIndex = off ? 0 : -1;
      }).observe(atc);
    }

    update(false);
  }

  function boot() {
    document.querySelectorAll('[data-qs-buy]').forEach(function (r) {
      if (r.__qs) return;
      r.__qs = true;
      try { initBuy(r); } catch (e) { console.error('[qs]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
